import { createSelector } from 'reselect';
import { languageNameMap } from '../config';
import { replaceLocaleForUrl } from '../utils/locale';

const getLocale = (state) => state.request.locale;
const getLanguages = (state) => state.request.country.languages;
const getCurrentUrl = (state) => state.request.currentUrl;
const getAlternateUrls = (state) => state.request.alternateUrls;

/* eslint-disable import/prefer-default-export */

/**
 * Where a given page has supplied alternate language URLs in
 * state.request.alternateUrls, use them. Otherwise we assume that a
 * corresponding page exists for each locale this market supports, and so
 * generate an array of alternates based on the current URL.
 */
export const getAlternateLanguageUrls = createSelector(
  [getLocale, getLanguages, getCurrentUrl, getAlternateUrls],
  (currentLocale, languages, currentUrl, alternateUrls) => {
    if (alternateUrls.length > 0) {
      return alternateUrls.map(({ locale, url }) => ({
        label: languageNameMap[locale].name,
        href: url,
        selected: locale === currentLocale,
      }));
    }

    return languages.map((locale) => ({
      label: languageNameMap[locale].name,
      href: replaceLocaleForUrl(locale, currentUrl),
      selected: locale === currentLocale,
    }));
  },
);
